var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.001,
    height: 10.978,
    viewBox: "0 0 13.001 10.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.115 11.103) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.072,10.8.294,6.022A.61.61,0,0,1,.079,5.2.6.6,0,0,1,.253,5L5.072.178a.609.609,0,0,1,.861.862L2.082,4.891H12.391a.609.609,0,1,1,0,1.219H2.106L5.933,9.938a.609.609,0,1,1-.861.861Z",
    transform: "translate(0.114 0.125)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic_arrow.b7e0b18afb4283911f79edf21a35fb40.svg";
export { ForwardRef as ReactComponent };